export const MEASUREMENT_UNITS = ['B', 'KB', 'MB', 'GB'];
